// Title height (in px)
export const TITLE_HEIGHT: number = 64;
// Sidebar width when expanded (in px)
export const SIDEBAR_EXPANDED_WIDTH: number = 240;
// Feature panel width (in px)
export const FEATURE_PANEL_WIDTH: number = 270;
// Bounds of the right column (in px). It gives way on a narrow window rather
// than holding a fixed width the canvas would have to pay for
export const RIGHT_DOCK_MIN_WIDTH: number = 260;
export const RIGHT_DOCK_MAX_WIDTH: number = 360;
// The least canvas worth working in (in px). Below this there's no room to see
// a node and its neighbors at once, which is the whole job of the canvas
export const MIN_CANVAS_WIDTH: number = 480;
// The window width at which the sidebar, the feature panel, the canvas and the
// right column all fit at once. Under it, opening the right column makes room
// by closing the feature panel
export const THREE_COLUMN_MIN_WIDTH: number =
  SIDEBAR_EXPANDED_WIDTH +
  FEATURE_PANEL_WIDTH +
  MIN_CANVAS_WIDTH +
  RIGHT_DOCK_MAX_WIDTH;
